var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.6001 20C4.0501 20 3.57943 19.8043 3.1881 19.413C2.79676 19.0217 2.60076 18.5507 2.6001 18V6C2.6001 5.45 2.7961 4.97933 3.1881 4.588C3.5801 4.19667 4.05076 4.00067 4.6001 4H20.6001C21.1501 4 21.6211 4.196 22.0131 4.588C22.4051 4.98 22.6008 5.45067 22.6001 6V18C22.6001 18.55 22.4044 19.021 22.0131 19.413C21.6218 19.805 21.1508 20.0007 20.6001 20H4.6001ZM12.6001 13L4.6001 8V18H20.6001V8L12.6001 13ZM12.6001 11L20.6001 6H4.6001L12.6001 11ZM4.6001 8V6V18V8Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail_icon.ac45c58dbea9f7b3b2f2c8a8dc763423.svg";
export { ForwardRef as ReactComponent };